var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/main.js
import gsap3 from "https://esm.sh/gsap@3.12.5";
import ScrollTrigger2 from "https://esm.sh/gsap@3.12.5/ScrollTrigger";
import Lenis from "https://esm.sh/lenis@1.1.13";

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/content/site.js
var site = {
  brand: {
    name: "DAA Media Solutions",
    tagline: "Performance media buying for brands that want to scale.",
    email: "info@daamediasolutions.ae",
    address: "IFZA Business Park, Dubai Silicon Oasis, Dubai, UAE",
    // Phone intentionally empty: contact is email-only (cta hides the phone
    // link when this is falsy). Add a real number here to bring it back.
    phone: ""
  },
  hero: {
    headline: "We turn ad spend into growth.",
    sub: "A Dubai performance team running paid media that pays for itself. We write sharper creative, tighten your targeting, and optimize across every platform your customers actually use.",
    ctaPrimary: { label: "See packages", href: "#packages" },
    ctaSecondary: { label: "Book a call", href: "#cta" },
    ticker: [
      "GOOGLE ADS",
      "PINTEREST ADS",
      "META ADS",
      "TIKTOK ADS",
      "CREATIVE STRATEGY",
      "CRO",
      "FULL-FUNNEL",
      "PROFITABLE SCALE"
    ]
  },
  // ~4 count-up stats for the proof bar (real figures per Dylan).
  // `decimals` forces the rendered precision (4 -> "4.0").
  stats: [
    { value: 2, prefix: "$", suffix: "M+", label: "Ad spend managed" },
    { value: 4, decimals: 1, prefix: "", suffix: "x", label: "Average ROAS" },
    { value: 1e3, prefix: "", suffix: "+", label: "Campaigns launched" },
    { value: 10, prefix: "", suffix: "+", label: "Markets reached" }
  ],
  // Platform order per Dylan: Google, Pinterest, Meta, TikTok.
  platforms: [
    {
      key: "google",
      name: "Google",
      line: "Search, Shopping and Performance Max that catch buyers the moment they search.",
      color: "#EA4335"
    },
    {
      key: "pinterest",
      name: "Pinterest",
      line: "Discovery campaigns that reach buyers early and keep acquisition costs low.",
      color: "#E60023"
    },
    {
      key: "meta",
      name: "Meta",
      line: "Facebook and Instagram funnels built for low-cost clicks and retargeting that keeps working.",
      color: "#0866FF"
    },
    {
      key: "tiktok",
      name: "TikTok",
      line: "Native-feeling creative that turns a scroll into an add-to-cart.",
      color: "#FF0050"
    }
  ],
  // EXACT packages. Do not change prices or popular flags.
  // Order per Dylan: Google, Pinterest, Facebook (Meta), TikTok.
  packages: [
    {
      id: "google",
      name: "Google Ads",
      price: 995,
      currency: "USD",
      popular: true,
      features: [
        "Search, Shopping & Performance Max",
        "Keyword & negative-list engineering",
        "Conversion tracking + GA4 wiring",
        "Bid strategy management",
        "Weekly optimization & scaling"
      ],
      buyUrl: "https://daamediasolutions.ae/products/google-advertisement-management"
    },
    {
      id: "pinterest",
      name: "Pinterest Ads",
      price: 695,
      currency: "USD",
      popular: false,
      features: [
        "Full funnel campaign architecture",
        "Pin & idea-ad creative direction",
        "Audience & keyword targeting",
        "Conversion tracking setup",
        "Bi-weekly optimization"
      ],
      buyUrl: "https://daamediasolutions.ae/products/pinterest-advertisement-management"
    },
    {
      id: "facebook",
      name: "Facebook Ads",
      price: 795,
      currency: "USD",
      popular: false,
      features: [
        "Full Meta account audit & setup",
        "Conversion API + pixel hardening",
        "Creative testing framework",
        "Weekly optimization & scaling",
        "Transparent live reporting dashboard"
      ],
      buyUrl: "https://daamediasolutions.ae/products/facebook-advertisement-management"
    },
    {
      id: "tiktok",
      name: "TikTok Ads",
      price: 695,
      currency: "USD",
      popular: false,
      features: [
        "TikTok pixel & events setup",
        "UGC-style creative briefs",
        "Spark Ads & whitelisting strategy",
        "Audience testing & scaling",
        "Bi-weekly optimization"
      ],
      buyUrl: "https://daamediasolutions.ae/products/tiktok-advertisement-management"
    }
  ],
  // 5 process steps
  process: [
    {
      step: 1,
      title: "Audit",
      desc: "We tear down your accounts, tracking and creative to find exactly where money is leaking."
    },
    {
      step: 2,
      title: "Strategy",
      desc: "A full-funnel plan built around your margins and your market, with a realistic path to profitable scale."
    },
    {
      step: 3,
      title: "Launch",
      desc: "Campaigns, pixels and creative go live with clean tracking and clear KPIs from day one."
    },
    {
      step: 4,
      title: "Optimize",
      desc: "Daily data reviews, quick cuts on what is not working and fresh creative to bring cost per result down."
    },
    {
      step: 5,
      title: "Scale",
      desc: "Once the unit economics work, we push budget into the winning campaigns and expand into new markets."
    }
  ],
  results: {
    headline: "Numbers our clients actually care about.",
    // Growth curve: first -> last = +200% (per Dylan). The statement figure
    // is derived from this series.
    chart: [40, 52, 67, 84, 103, 120],
    // Testimonials + client names REMOVED per Dylan (the previous entries
    // were fictional placeholders; he does not want invented or leaked client
    // names on the live site). The section hides these blocks when empty.
    // To bring them back: add real, approved quotes/names here.
    testimonials: [],
    clients: []
  }
};

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/motion.js
var motion_exports = {};
__export(motion_exports, {
  EASE: () => EASE,
  FINE_POINTER: () => FINE_POINTER,
  REDUCED: () => REDUCED,
  SCRUB: () => SCRUB,
  SMALL: () => SMALL,
  countScrub: () => countScrub,
  default: () => motion_default,
  parallax: () => parallax,
  pinnedScene: () => pinnedScene,
  revealScrub: () => revealScrub
});
import gsap from "https://esm.sh/gsap@3.12.5";
import ScrollTrigger from "https://esm.sh/gsap@3.12.5/ScrollTrigger";
var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
var FINE_POINTER = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
var SMALL = () => window.matchMedia("(max-width: 720px)").matches;
var EASE = "power3.out";
var SCRUB = 0.6;
var NATURAL = {
  opacity: 1,
  y: 0,
  x: 0,
  yPercent: 0,
  xPercent: 0,
  rotate: 0,
  rotateX: 0,
  rotateY: 0,
  rotation: 0,
  scale: 1,
  scaleX: 1,
  scaleY: 1,
  filter: "blur(0px)"
};
function naturalOf(from) {
  const to = {};
  for (const k of Object.keys(from)) to[k] = k in NATURAL ? NATURAL[k] : 0;
  return to;
}
function revealScrub(targets, {
  from = { opacity: 0, y: 44 },
  trigger,
  start = "top 85%",
  end = "top 48%",
  stagger = 0.08,
  scrub = SCRUB,
  ease = EASE
} = {}) {
  const els = gsap.utils.toArray(targets);
  if (!els.length) return null;
  if (REDUCED) {
    gsap.set(els, naturalOf(from));
    return null;
  }
  gsap.set(els, from);
  return gsap.to(els, {
    ...naturalOf(from),
    ease,
    stagger,
    scrollTrigger: { trigger: trigger || els[0], start, end, scrub }
  });
}
function pinnedScene(trigger, build, { start = "top top", end = "+=120%", scrub = SCRUB } = {}) {
  if (REDUCED) {
    const tl2 = gsap.timeline();
    build(tl2);
    tl2.progress(1).kill();
    return null;
  }
  const tl = gsap.timeline({
    scrollTrigger: { trigger, start, end, scrub, pin: true, anticipatePin: 1 }
  });
  build(tl);
  return tl;
}
function parallax(target, { yPercent = -12, start = "top bottom", end = "bottom top" } = {}) {
  const el = gsap.utils.toArray(target)[0];
  if (!el || REDUCED) return null;
  return gsap.fromTo(el, { yPercent: 0 }, {
    yPercent,
    ease: "none",
    scrollTrigger: { trigger: el, start, end, scrub: true }
  });
}
function countScrub(el, endVal, {
  trigger,
  start = "top 88%",
  end = "top 52%",
  scrub = SCRUB,
  format = (v) => Math.round(v).toLocaleString("en-US")
} = {}) {
  if (!el) return null;
  if (REDUCED) {
    el.textContent = format(endVal);
    return null;
  }
  const proxy = { v: 0 };
  el.textContent = format(0);
  return gsap.to(proxy, {
    v: endVal,
    ease: "none",
    onUpdate: () => {
      el.textContent = format(proxy.v);
    },
    scrollTrigger: { trigger: trigger || el, start, end, scrub }
  });
}
var motion_default = { REDUCED, FINE_POINTER, SMALL, EASE, SCRUB, revealScrub, pinnedScene, parallax, countScrub };

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/scene/index.js
import * as THREE2 from "https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js";

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/scene/particles.js
import * as THREE from "https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js";
var P_VERT = (
  /* glsl */
  `
uniform float uTime;
uniform float uProgress;
uniform vec2  uPointer;
uniform float uSpread;
uniform float uStream;
uniform float uSize;

attribute float aScale;     // per-point size variance
attribute float aSeed;      // per-point random 0..1
attribute vec3  aAxis;      // orbit axis (unit)
attribute float aRadius;    // base shell radius

varying float vSeed;
varying float vTwinkle;

// rotate v around unit axis by angle (Rodrigues)
vec3 rotateAxis(vec3 v, vec3 axis, float a){
  float c = cos(a);
  float s = sin(a);
  return v * c + cross(axis, v) * s + axis * dot(axis, v) * (1.0 - c);
}

void main(){
  vSeed = aSeed;
  vec3 pos = position;

  // slow per-point orbit around its own axis
  float spin = uTime * (0.06 + aSeed * 0.12);
  pos = rotateAxis(pos, normalize(aAxis), spin);

  // services beat: push the whole shell outward
  pos *= (1.0 + uSpread * (0.8 + aSeed * 1.4));

  // pointer parallax \u2014 subtle drift toward cursor
  pos.xy += uPointer * (0.15 + aSeed * 0.2);

  // process beat: stream upward, wrapping in a tall column
  float colH = 9.0;
  float rise = mod(uTime * (0.8 + aSeed * 1.2) + aSeed * colH, colH);
  vec3 streamPos = vec3(
    pos.x * 0.45 + sin(uTime * 0.5 + aSeed * 6.28) * 0.4,
    pos.y * 0.2 - colH * 0.5 + rise,
    pos.z * 0.45 + cos(uTime * 0.5 + aSeed * 6.28) * 0.4
  );
  pos = mix(pos, streamPos, uStream);

  vec4 mvPosition = modelViewMatrix * vec4(pos, 1.0);

  // twinkle so the field shimmers
  vTwinkle = 0.5 + 0.5 * sin(uTime * (1.0 + aSeed * 3.0) + aSeed * 12.0);

  // distance-scaled, twinkled \u2014 but CAPPED so points drifting near the camera
  // can't balloon into big additive blobs that wash the whole frame to grey.
  float psize = uSize * aScale * (165.0 / -mvPosition.z) * (0.55 + vTwinkle * 0.5);
  gl_PointSize = clamp(psize, 0.0, 20.0);
  gl_Position = projectionMatrix * mvPosition;
}
`
);
var P_FRAG = (
  /* glsl */
  `
precision mediump float;
uniform vec3  uColorA;
uniform vec3  uColorB;
uniform float uOpacity;
uniform float uStream;

varying float vSeed;
varying float vTwinkle;

void main(){
  // soft round sprite
  vec2 uv = gl_PointCoord - 0.5;
  float d = length(uv);
  float alpha = smoothstep(0.5, 0.0, d);
  alpha *= alpha;

  vec3 col = mix(uColorA, uColorB, vSeed);
  // keep per-point energy well under 1.0 so the additive field reads as sparse
  // neon glints on black, not an accumulated bright haze.
  col *= 0.22 + vTwinkle * 0.42;

  gl_FragColor = vec4(col, alpha * uOpacity);
  if (gl_FragColor.a < 0.01) discard;
}
`
);
function createParticles({ count = 3500, colorA, colorB } = {}) {
  const geometry = new THREE.BufferGeometry();
  const positions = new Float32Array(count * 3);
  const scales = new Float32Array(count);
  const seeds = new Float32Array(count);
  const axes = new Float32Array(count * 3);
  const radii = new Float32Array(count);
  const v = new THREE.Vector3();
  const ax = new THREE.Vector3();
  for (let i = 0; i < count; i++) {
    const r = 1.6 + Math.pow(Math.random(), 0.6) * 3.4;
    const u = Math.random() * 2 - 1;
    const theta = Math.random() * Math.PI * 2;
    const s = Math.sqrt(1 - u * u);
    v.set(s * Math.cos(theta), u, s * Math.sin(theta)).multiplyScalar(r);
    positions[i * 3 + 0] = v.x;
    positions[i * 3 + 1] = v.y;
    positions[i * 3 + 2] = v.z;
    scales[i] = 0.4 + Math.random() * 1.6;
    seeds[i] = Math.random();
    radii[i] = r;
    ax.set(Math.random() * 2 - 1, Math.random() * 2 - 1, Math.random() * 2 - 1).normalize();
    axes[i * 3 + 0] = ax.x;
    axes[i * 3 + 1] = ax.y;
    axes[i * 3 + 2] = ax.z;
  }
  geometry.setAttribute("position", new THREE.BufferAttribute(positions, 3));
  geometry.setAttribute("aScale", new THREE.BufferAttribute(scales, 1));
  geometry.setAttribute("aSeed", new THREE.BufferAttribute(seeds, 1));
  geometry.setAttribute("aAxis", new THREE.BufferAttribute(axes, 3));
  geometry.setAttribute("aRadius", new THREE.BufferAttribute(radii, 1));
  const uniforms = {
    uTime: { value: 0 },
    uProgress: { value: 0 },
    uPointer: { value: new THREE.Vector2(0, 0) },
    uColorA: { value: colorA || new THREE.Color("#00E5FF") },
    uColorB: { value: colorB || new THREE.Color("#FF2E9A") },
    uSpread: { value: 0 },
    uStream: { value: 0 },
    uSize: { value: 2.4 },
    uOpacity: { value: 0.55 }
  };
  const material = new THREE.ShaderMaterial({
    uniforms,
    vertexShader: P_VERT,
    fragmentShader: P_FRAG,
    transparent: true,
    depthWrite: false,
    depthTest: true,
    blending: THREE.AdditiveBlending
  });
  const points = new THREE.Points(geometry, material);
  points.frustumCulled = false;
  return { points, material, uniforms, geometry };
}

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/scene/choreography.js
var clamp01 = (v) => v < 0 ? 0 : v > 1 ? 1 : v;
var lerp = (a, b, t) => a + (b - a) * t;
var smooth = (t) => {
  t = clamp01(t);
  return t * t * (3 - 2 * t);
};
var seg = (p, a, b) => smooth((p - a) / (b - a));
function choreograph(progress) {
  const p = clamp01(progress);
  const wHero = 1 - seg(p, 0, 0.3);
  const wServices = seg(p, 0.18, 0.32) * (1 - seg(p, 0.42, 0.52));
  const wPackages = seg(p, 0.42, 0.52) * (1 - seg(p, 0.62, 0.72));
  const wProcess = seg(p, 0.62, 0.74) * (1 - seg(p, 0.82, 0.92));
  const wCta = seg(p, 0.84, 1);
  const camZ = lerp(4, 4, 0) + wServices * 2.4 + wPackages * 2 + wProcess * 1.4 + wCta * 0.6;
  const camX = wPackages * 2.6 * Math.sin(p * Math.PI * 2) + wServices * 0.6;
  const camY = wServices * 1.1 + wPackages * 0.4 - wProcess * 1.6 + // look down as particles rise
  wCta * 0.2;
  const lookY = -wProcess * 1.2 - wCta * 1.5;
  const fov = lerp(42, 50, smooth(wServices + wPackages * 0.5)) - wCta * 4;
  const displace = 0.14 + wHero * 0.1 + wServices * 0.05 + wProcess * 0.08 + wCta * 0.04;
  const fragment = wPackages * 0.7 + // explode into shards
  wProcess * 0.3;
  const presence = Math.max(
    0.18,
    wHero * 1 + wServices * 0.3 + wPackages * 0.28 + wProcess * 0.26 + wCta * 0.5
  );
  const brightness = (0.95 + wCta * 0.45) * presence;
  const scale = 1 - wServices * 0.12 - wPackages * 0.1 - wProcess * 0.08 - wCta * 0.04;
  const spin = 0.12 + wServices * 0.1 + wPackages * 0.25 + wCta * 0.15;
  const rotX = wProcess * 0.4 + wServices * 0.15;
  const spread = wServices * 0.9 + wPackages * 0.5;
  const stream = wProcess;
  const pOpacity = (0.2 + wHero * 0.1 + wServices * 0.14 + wProcess * 0.2 + wCta * 0.12) * Math.max(0.4, presence);
  const pSize = 2.2 + wProcess * 1.3 + wCta * 0.8;
  const nodeOpacity = (wServices * 0.9 + wPackages * 1 + wProcess * 0.4 + wCta * 0.5) * Math.max(0.55, presence);
  const nodeSpread = wServices * 1 + wPackages * 1.5;
  const nodeSpeed = 0.4 + wServices * 0.3 + wPackages * 0.8 + wCta * 0.3;
  return {
    camera: { pos: [camX, camY, camZ], look: [0, lookY, 0], fov },
    core: { displace, brightness, fragment, scale, spin, rotX },
    particles: { spread, stream, opacity: pOpacity, size: pSize },
    nodes: { opacity: nodeOpacity, spread: nodeSpread, speed: nodeSpeed },
    beats: {
      hero: wHero,
      services: wServices,
      packages: wPackages,
      process: wProcess,
      cta: wCta
    }
  };
}

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/scene/index.js
function initScene(canvas, { reducedMotion = false } = {}) {
  let width = canvas.clientWidth || window.innerWidth;
  let height = canvas.clientHeight || window.innerHeight;
  const isSmall = () => Math.min(window.innerWidth, window.innerHeight) < 720;
  const particleCount = isSmall() ? 1600 : 3500;
  const renderer = new THREE2.WebGLRenderer({
    canvas,
    antialias: !isSmall(),
    alpha: true,
    powerPreference: "high-performance"
  });
  renderer.setClearColor(0, 0);
  const maxDpr = isSmall() ? 1.75 : 2;
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, maxDpr));
  renderer.setSize(width, height, false);
  renderer.outputColorSpace = THREE2.SRGBColorSpace;
  const scene = new THREE2.Scene();
  const camera = new THREE2.PerspectiveCamera(42, width / height, 0.1, 100);
  camera.position.set(0, 0, 4);
  const colorA = new THREE2.Color("#FED501");
  const colorB = new THREE2.Color("#FFE24D");
  const partParts = createParticles({ count: particleCount, colorA, colorB });
  const root = new THREE2.Group();
  root.add(partParts.points);
  scene.add(root);
  root.position.set(0.2, 0, 0);
  root.scale.setScalar(0.9);
  let progress = 0;
  const pointer = new THREE2.Vector2(0, 0);
  const pointerTarget = new THREE2.Vector2(0, 0);
  let running = false;
  let rafId = 0;
  let visible = true;
  let onScreen = true;
  let disposed = false;
  const clock = new THREE2.Clock(false);
  let elapsed = 0;
  const tmpLook = new THREE2.Vector3();
  function applyState(dt) {
    const st = choreograph(progress);
    const ease = 1 - Math.pow(1e-3, dt);
    pointer.x += (pointerTarget.x - pointer.x) * ease;
    pointer.y += (pointerTarget.y - pointer.y) * ease;
    camera.position.x += (st.camera.pos[0] - camera.position.x) * Math.min(1, dt * 4);
    camera.position.y += (st.camera.pos[1] - camera.position.y) * Math.min(1, dt * 4);
    camera.position.z += (st.camera.pos[2] - camera.position.z) * Math.min(1, dt * 4);
    camera.position.x += pointer.x * 0.25;
    camera.position.y += pointer.y * 0.18;
    tmpLook.set(st.camera.look[0], st.camera.look[1], st.camera.look[2]);
    camera.lookAt(tmpLook);
    if (Math.abs(camera.fov - st.camera.fov) > 0.01) {
      camera.fov += (st.camera.fov - camera.fov) * Math.min(1, dt * 4);
      camera.updateProjectionMatrix();
    }
    const pu = partParts.uniforms;
    pu.uTime.value = elapsed;
    pu.uProgress.value = progress;
    pu.uPointer.value.copy(pointer);
    pu.uSpread.value = st.particles.spread;
    pu.uStream.value = st.particles.stream;
    pu.uOpacity.value = st.particles.opacity * 0.5;
    pu.uSize.value = st.particles.size;
    root.rotation.y = Math.sin(elapsed * 0.05) * 0.06 + pointer.x * 0.05;
  }
  function renderOnce() {
    renderer.render(scene, camera);
  }
  function frame() {
    if (!running) return;
    const dt = Math.min(clock.getDelta(), 0.05);
    elapsed += dt;
    applyState(dt);
    renderOnce();
    rafId = requestAnimationFrame(frame);
  }
  function start() {
    if (running || reducedMotion || disposed) return;
    if (!visible || !onScreen) return;
    running = true;
    clock.start();
    clock.getDelta();
    rafId = requestAnimationFrame(frame);
  }
  function stop() {
    running = false;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = 0;
    clock.stop();
  }
  function onVisibility() {
    visible = document.visibilityState !== "hidden";
    if (visible) start();
    else stop();
  }
  document.addEventListener("visibilitychange", onVisibility);
  let io = null;
  if ("IntersectionObserver" in window) {
    io = new IntersectionObserver(
      (entries) => {
        onScreen = entries.some((e) => e.isIntersecting);
        if (onScreen) start();
        else stop();
      },
      { threshold: 0 }
    );
    io.observe(canvas);
  }
  function setProgress(p) {
    progress = p < 0 ? 0 : p > 1 ? 1 : p;
    if (!running && reducedMotion) {
      applyState(0);
      renderOnce();
    }
  }
  function setPointer(x, y) {
    pointerTarget.set(
      Math.max(-1, Math.min(1, x || 0)),
      Math.max(-1, Math.min(1, y || 0))
    );
  }
  function resize() {
    width = canvas.clientWidth || window.innerWidth;
    height = canvas.clientHeight || window.innerHeight;
    const maxD = isSmall() ? 1.75 : 2;
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, maxD));
    renderer.setSize(width, height, false);
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
    if (!running) renderOnce();
  }
  window.addEventListener("resize", resize);
  function pause() {
    stop();
  }
  function resume() {
    start();
  }
  function dispose() {
    disposed = true;
    stop();
    document.removeEventListener("visibilitychange", onVisibility);
    window.removeEventListener("resize", resize);
    if (io) io.disconnect();
    partParts.geometry.dispose();
    partParts.material.dispose();
    renderer.dispose();
  }
  resize();
  if (reducedMotion) {
    progress = 0;
    elapsed = 0;
    applyState(0);
    renderOnce();
  } else {
    start();
    applyState(0);
    renderOnce();
  }
  return { setProgress, setPointer, resize, pause, resume, dispose };
}

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/sections/hero.js
var hero_exports = {};
__export(hero_exports, {
  default: () => hero_default,
  initHero: () => initHero
});
var HERO_CSS_HREF = "css/sections/hero.css";
function ensureStyles() {
  const already = [...document.styleSheets].some(
    (s) => s.href && s.href.includes("sections/hero.css")
  );
  if (already) return;
  if (document.querySelector("link[data-hero-css]")) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = HERO_CSS_HREF;
  link.setAttribute("data-hero-css", "");
  document.head.appendChild(link);
}
function esc(str) {
  return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function posterLines(headline) {
  const words = String(headline).trim().split(/\s+/);
  if (words.length < 4) return [words.join(" ")];
  const a = words.slice(0, 2).join(" ");
  const b = words.slice(2, 4).join(" ");
  const c = words.slice(4).join(" ");
  return c ? [a, b, c] : [a, b];
}
function lineMarkup(line, isLast) {
  if (!isLast) {
    return `<span class="hero__line"><span class="hero__line-inner">${esc(line)}</span></span>`;
  }
  const words = line.split(/\s+/);
  const accent = words.pop() || "";
  const rest = words.join(" ");
  return `<span class="hero__line"><span class="hero__line-inner">` + (rest ? `${esc(rest)} ` : "") + `<em class="serif-accent hero__gold">${esc(accent)}</em></span></span>`;
}
function initHero(ctx) {
  const { gsap: gsap4, site: site2 } = ctx || {};
  const root = document.getElementById("hero");
  if (!root) return;
  ensureStyles();
  const data = site2 && site2.hero || {};
  const brand = site2 && site2.brand || {};
  const stats = site2 && Array.isArray(site2.stats) && site2.stats || [];
  const headline = data.headline || "We turn ad spend into growth.";
  const sub = data.sub || "";
  const ctaPrimary = data.ctaPrimary || { label: "See packages", href: "#packages" };
  const ctaSecondary = data.ctaSecondary || { label: "Book a call", href: "#cta" };
  const reduced = REDUCED;
  const lines = posterLines(headline);
  const titleMarkup = lines.map((l, i) => lineMarkup(l, i === lines.length - 1)).join("");
  const ticker = Array.isArray(data.ticker) && data.ticker.length ? data.ticker : ["META ADS", "GOOGLE ADS", "TIKTOK ADS", "PINTEREST ADS"];
  const marqueeRun = ticker.map((t) => `<span class="hero__mq-item">${esc(t)}</span>`).join('<span class="hero__mq-dot" aria-hidden="true"></span>');
  const spend = stats[0] ? `${stats[0].prefix || ""}${Number(stats[0].value).toLocaleString("en-US")}${stats[0].suffix || ""}` : "$40M+";
  root.innerHTML = `
    <div class="hero">
      <img class="hero__art" src="${(window.DAA_ASSETS && window.DAA_ASSETS.artSwirl) || 'assets/art-swirl.jpg'}" alt="" aria-hidden="true"
           width="1920" height="1080" decoding="async" fetchpriority="high" />

      <header class="hero__topbar container">
        <a class="hero__brand microlabel" href="#hero">${esc(brand.name || "DAA Media Solutions")}</a>
        <div class="hero__meta">
          <span class="microlabel">Dubai, UAE</span>
          <span class="microlabel hero__booking"><span class="hero__dot" aria-hidden="true"></span>Now booking Q4</span>
        </div>
      </header>

      <div class="hero__stage container">
        <p class="microlabel hero__eyebrow">(Performance media, done properly)</p>
        <h1 class="hero__title">${titleMarkup}</h1>

        <div class="hero__foot">
          <p class="hero__sub">${esc(sub)}</p>
          <div class="hero__ctas">
            <a class="btn btn--fill btn--magnetic" href="${esc(ctaPrimary.href || "#packages")}" data-cursor>
              ${esc(ctaPrimary.label || "See packages")}
            </a>
            <a class="btn" href="${esc(ctaSecondary.href || "#cta")}" data-cursor>
              ${esc(ctaSecondary.label || "Book a call")}
            </a>
          </div>
          <p class="microlabel hero__trust">Trusted with ${esc(spend)} in ad spend</p>
        </div>
      </div>

      <div class="hero__mq hairline-top" aria-hidden="true">
        <div class="hero__mq-track">
          <div class="hero__mq-group">${marqueeRun}<span class="hero__mq-dot"></span></div>
          <div class="hero__mq-group">${marqueeRun}<span class="hero__mq-dot"></span></div>
        </div>
      </div>
    </div>
  `;
  const hero = root.querySelector(".hero");
  const lineInners = root.querySelectorAll(".hero__line-inner");
  const eyebrow = root.querySelector(".hero__eyebrow");
  const foot = root.querySelector(".hero__foot");
  const topbar = root.querySelector(".hero__topbar");
  const art = root.querySelector(".hero__art");
  const magnetics = root.querySelectorAll(".btn--magnetic");
  if (!gsap4) {
    if (hero) hero.classList.add("is-ready");
    return;
  }
  if (reduced) {
    gsap4.set([eyebrow, foot, topbar, art], { opacity: 1, clearProps: "transform" });
    gsap4.set(lineInners, { yPercent: 0 });
    if (hero) hero.classList.add("is-ready");
    return;
  }
  gsap4.set(lineInners, { yPercent: 112 });
  gsap4.set([eyebrow, foot], { opacity: 0, y: 14 });
  gsap4.set(topbar, { opacity: 0 });
  gsap4.set(art, { opacity: 0, scale: 1.04, transformOrigin: "80% 60%" });
  if (hero) hero.classList.add("is-ready");
  const tl = gsap4.timeline({ defaults: { ease: "power4.out" }, delay: 0.1 });
  tl.to(art, { opacity: 1, scale: 1, duration: 1.6, ease: "power2.out" }).to(topbar, { opacity: 1, duration: 0.7 }, "-=1.3").to(eyebrow, { opacity: 1, y: 0, duration: 0.6 }, "-=1.1").to(lineInners, { yPercent: 0, duration: 1.1, stagger: 0.12 }, "-=0.9").to(foot, { opacity: 1, y: 0, duration: 0.7 }, "-=0.55");
  const st = gsap4.timeline({
    scrollTrigger: { trigger: root, start: "top top", end: "bottom top", scrub: true }
  });
  st.fromTo(
    lineInners,
    { y: 0 },
    { y: (i) => -40 - i * 26, ease: "none" },
    0
  ).fromTo([eyebrow, foot], { opacity: 1 }, { opacity: 0, ease: "none" }, 0).fromTo(art, { yPercent: 0 }, { yPercent: 14, ease: "none" }, 0);
  const finePointer2 = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (finePointer2) {
    magnetics.forEach((btn) => {
      const qx = gsap4.quickTo(btn, "x", { duration: 0.4, ease: "power3.out" });
      const qy = gsap4.quickTo(btn, "y", { duration: 0.4, ease: "power3.out" });
      btn.addEventListener("pointermove", (e) => {
        const r = btn.getBoundingClientRect();
        qx(Math.max(-10, Math.min(10, (e.clientX - r.left - r.width / 2) * 0.3)));
        qy(Math.max(-10, Math.min(10, (e.clientY - r.top - r.height / 2) * 0.3)));
      });
      btn.addEventListener("pointerleave", () => {
        qx(0);
        qy(0);
      });
    });
  }
}
var hero_default = initHero;

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/sections/proof.js
var proof_exports = {};
__export(proof_exports, {
  default: () => proof_default,
  initProof: () => initProof
});
var CSS_HREF = "css/sections/proof.css";
function ensureStyles2() {
  const already = [...document.styleSheets].some(
    (s) => s.href && s.href.includes("sections/proof.css")
  );
  if (already) return;
  if (document.querySelector("link[data-proof-css]")) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = CSS_HREF;
  link.setAttribute("data-proof-css", "");
  document.head.appendChild(link);
}
function esc2(str) {
  return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function decimalsOf(n) {
  if (!Number.isFinite(n)) return 0;
  const s = String(n);
  const dot = s.indexOf(".");
  return dot === -1 ? 0 : s.length - dot - 1;
}
function formatNumber(value, decimals) {
  return Number(value).toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}
function render(el, site2) {
  const stats = Array.isArray(site2 && site2.stats) ? site2.stats : [];
  const cols = stats.map((s) => {
    const prefix = s.prefix || "";
    const suffix = s.suffix || "";
    const decimals = Number.isFinite(s.decimals) ? s.decimals : decimalsOf(s.value);
    const finalText = formatNumber(s.value, decimals);
    const spoken = `${prefix}${finalText}${suffix}`;
    return `
        <div class="proof__stat">
          <p class="proof__value" aria-label="${esc2(spoken)}">
            <span class="proof__clip"><span class="proof__clip-inner">${prefix ? `<span class="proof__affix" aria-hidden="true">${esc2(prefix)}</span>` : ""}<span class="proof__num" aria-hidden="true"
              data-value="${esc2(String(s.value))}"
              data-decimals="${decimals}">${esc2(finalText)}</span>${suffix ? `<span class="proof__affix" aria-hidden="true">${esc2(suffix)}</span>` : ""}</span></span>
          </p>
          <p class="microlabel proof__label">${esc2(s.label || "")}</p>
        </div>`;
  }).join("");
  el.innerHTML = `
    <div class="container">
      <header class="proof__head">
        <span class="proof__rule" aria-hidden="true"></span>
        <span class="microlabel">(01) Track record</span>
        <span class="microlabel proof__annot">Numbers first, adjectives never</span>
      </header>
      <div class="proof__row">
        ${cols}
      </div>
    </div>`;
  return el.querySelector(".proof__row");
}
function initProof(ctx) {
  const { gsap: gsap4, ScrollTrigger: ScrollTrigger3, site: site2 } = ctx || {};
  const el = document.getElementById("proof");
  if (!el) return;
  ensureStyles2();
  const row = render(el, site2);
  if (!row) return;
  if (!gsap4 || !ScrollTrigger3 || REDUCED) return;
  const head = el.querySelector(".proof__head");
  const rule = el.querySelector(".proof__rule");
  const labels = Array.from(head.querySelectorAll(".microlabel"));
  const stats = Array.from(row.querySelectorAll(".proof__stat"));
  const clips = Array.from(row.querySelectorAll(".proof__clip-inner"));
  const nums = Array.from(row.querySelectorAll(".proof__num"));
  gsap4.fromTo(
    rule,
    { scaleX: 0 },
    {
      scaleX: 1,
      ease: "none",
      transformOrigin: "0 50%",
      scrollTrigger: { trigger: head, start: "top 88%", end: "top 62%", scrub: SCRUB }
    }
  );
  revealScrub(labels, {
    from: { opacity: 0, y: 10 },
    trigger: head,
    start: "top 88%",
    end: "top 62%",
    stagger: 0.08
  });
  revealScrub(stats, {
    from: { opacity: 0, y: 40 },
    trigger: row,
    start: "top 88%",
    end: "top 52%",
    stagger: 0.09
  });
  revealScrub(clips, {
    from: { yPercent: 112 },
    trigger: row,
    start: "top 82%",
    end: "top 55%",
    stagger: 0.09
  });
  nums.forEach((num) => {
    const target = parseFloat(num.dataset.value);
    const decimals = parseInt(num.dataset.decimals, 10) || 0;
    if (!Number.isFinite(target)) return;
    countScrub(num, target, {
      trigger: row,
      start: "top 86%",
      end: "top 50%",
      format: (v) => formatNumber(v, decimals)
    });
  });
}
var proof_default = initProof;

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/sections/services.js
var services_exports = {};
__export(services_exports, {
  default: () => services_default,
  initServices: () => initServices
});
var SECTION_ID = "services";
var CSS_HREF2 = "css/sections/services.css";
function ensureStylesheet() {
  if (document.querySelector(`link[data-section-css="${SECTION_ID}"]`)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = CSS_HREF2;
  link.setAttribute("data-section-css", SECTION_ID);
  document.head.appendChild(link);
}
function esc3(str) {
  return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function rowMarkup(platform, i) {
  const num = String(i + 1).padStart(2, "0");
  return `
    <li class="svc__row" data-svc-row>
      <div class="svc__row-in container">
        <span class="svc__idx microlabel" aria-hidden="true">${num}.</span>
        <h3 class="svc__name"><span class="svc__clip"><span class="svc__clip-inner">${esc3(platform.name)}</span></span></h3>
        <p class="svc__line">${esc3(platform.line)}</p>
      </div>
    </li>`;
}
function initServices(ctx) {
  const { gsap: gsap4, ScrollTrigger: ScrollTrigger3, site: site2 } = ctx || {};
  const root = document.getElementById(SECTION_ID);
  if (!root) return;
  ensureStylesheet();
  const platforms = site2 && Array.isArray(site2.platforms) ? site2.platforms : [];
  root.innerHTML = `
    <div class="container">
      <header class="svc__head">
        <span class="svc__rule" aria-hidden="true"></span>
        <span class="microlabel">(02) What we run</span>
        <span class="microlabel">Four platforms, one obsession</span>
      </header>
    </div>
    <ul class="svc__list" role="list">
      ${platforms.map(rowMarkup).join("")}
    </ul>
  `;
  if (!gsap4 || !ScrollTrigger3 || REDUCED) return;
  const head = root.querySelector(".svc__head");
  if (head) {
    revealScrub(head.querySelector(".svc__rule"), {
      from: { scaleX: 0 },
      ease: "none",
      trigger: head,
      start: "top 88%",
      end: "top 64%"
    });
    revealScrub(head.querySelectorAll(".microlabel"), {
      from: { opacity: 0, y: 10 },
      trigger: head,
      start: "top 88%",
      end: "top 64%",
      stagger: 0.1
    });
  }
  root.querySelectorAll("[data-svc-row]").forEach((row) => {
    revealScrub(row, {
      from: { opacity: 0, y: 36 },
      trigger: row,
      start: "top 90%",
      end: "top 60%"
    });
    revealScrub(row.querySelector(".svc__clip-inner"), {
      from: { yPercent: 112 },
      trigger: row,
      start: "top 82%",
      end: "top 55%"
    });
  });
}
var services_default = initServices;

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/sections/packages.js
var packages_exports = {};
__export(packages_exports, {
  default: () => packages_default,
  initPackages: () => initPackages
});
var CSS_HREF3 = "css/sections/packages.css";
function ensureStyles3() {
  const already = [...document.styleSheets].some(
    (s) => s.href && s.href.includes("sections/packages.css")
  );
  if (already) return;
  if (document.querySelector("link[data-pkg-css]")) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = CSS_HREF3;
  link.setAttribute("data-pkg-css", "");
  document.head.appendChild(link);
}
function esc4(str) {
  return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function rowMarkup2(pkg) {
  const symbol = pkg.currency === "USD" ? "$" : esc4(pkg.currency || "");
  const amount = Number(pkg.price).toLocaleString("en-US");
  const featureLine = (pkg.features || []).map(esc4).join(" / ");
  const tag = pkg.popular ? '<span class="microlabel packages__tag">Most popular</span>' : "";
  const startClass = pkg.popular ? "btn packages__start packages__start--popular" : "btn packages__start";
  return `
    <article class="packages__row" role="listitem" data-pkg="${esc4(pkg.id)}">
      <div class="packages__id">
        <h3 class="packages__name"><span>${esc4(pkg.name)}</span>${tag}</h3>
        <p class="packages__features">${featureLine}</p>
      </div>
      <p class="packages__price">
        <span class="packages__amount">${symbol}${amount}</span>
        <span class="microlabel packages__per">/mo</span>
      </p>
      <a class="${startClass}" href="${esc4(pkg.buyUrl || "#")}" target="_self"
         data-cursor="hover" aria-label="Start with ${esc4(pkg.name)}">Start</a>
    </article>`;
}
function initPackages(ctx) {
  const { site: site2 } = ctx || {};
  const root = document.getElementById("packages");
  if (!root) return;
  const packages = site2 && Array.isArray(site2.packages) ? site2.packages : [];
  if (!packages.length) return;
  ensureStyles3();
  root.innerHTML = `
    <div class="container">
      <header class="packages__head">
        <span class="packages__rule" aria-hidden="true"></span>
        <span class="microlabel">(03) Packages</span>
        <span class="microlabel">Simple monthly plans.</span>
      </header>

      <h2 class="packages__title">
        <span class="packages__title-line packages__clip"><span class="packages__clip-inner">Pick a platform.</span></span>
        <span class="packages__title-line packages__clip"><span class="packages__clip-inner">We make it <em class="serif-accent packages__gold">pay</em>.</span></span>
      </h2>

      <div class="packages__table" role="list">
        ${packages.map(rowMarkup2).join("")}
      </div>

      <p class="packages__note">
        Every plan is run by senior media buyers and backed by transparent,
        live reporting. Not sure which fits? Book a call and we will point
        your budget in the right direction.
      </p>
    </div>`;
  if (REDUCED) return;
  const head = root.querySelector(".packages__head");
  const rule = head.querySelector(".packages__rule");
  const labels = head.querySelectorAll(".microlabel");
  const title = root.querySelector(".packages__title");
  const lines = title.querySelectorAll(".packages__clip-inner");
  const rows = root.querySelectorAll(".packages__row");
  const note = root.querySelector(".packages__note");
  revealScrub(rule, {
    from: { scaleX: 0 },
    ease: "none",
    trigger: head,
    start: "top 88%",
    end: "top 62%"
  });
  revealScrub(labels, {
    from: { opacity: 0, y: 10 },
    trigger: head,
    start: "top 88%",
    end: "top 62%",
    stagger: 0.12
  });
  revealScrub(lines, {
    from: { yPercent: 112 },
    trigger: title,
    start: "top 82%",
    end: "top 55%",
    stagger: 0.12
  });
  revealScrub(rows, {
    from: { opacity: 0, y: 40 },
    trigger: root.querySelector(".packages__table"),
    start: "top 86%",
    end: "top 42%",
    stagger: 0.09
  });
  revealScrub(note, {
    from: { opacity: 0, y: 22 },
    trigger: note,
    start: "top 94%",
    end: "top 72%"
  });
}
var packages_default = initPackages;

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/sections/process.js
var process_exports = {};
__export(process_exports, {
  default: () => process_default,
  initProcess: () => initProcess
});
var HEAD_START = "top 82%";
var HEAD_END = "top 55%";
var CSS_HREF4 = "css/sections/process.css";
function ensureStyles4() {
  const already = [...document.styleSheets].some(
    (s) => s.href && s.href.includes("sections/process.css")
  );
  if (already) return;
  if (document.querySelector('link[data-section-css="process"]')) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = CSS_HREF4;
  link.dataset.sectionCss = "process";
  document.head.appendChild(link);
}
function esc5(str) {
  return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function buildMarkup(steps) {
  const cells = steps.map((s, i) => {
    const num = String(s.step ?? i + 1).padStart(2, "0");
    return `
        <li class="process__cell">
          <span class="process__index" aria-hidden="true">${esc5(num)}</span>
          <h3 class="process__cell-title">${esc5(s.title ?? "")}</h3>
          <p class="process__desc">${esc5(s.desc ?? "")}</p>
        </li>`;
  }).join("");
  return `
    <div class="container">
      <header class="process__head">
        <span class="process__head-rule" aria-hidden="true"></span>
        <span class="microlabel">(04) The process</span>
        <span class="microlabel process__note">The same loop on every account</span>
      </header>

      <h2 class="process__title"><span class="process__clip"><span class="process__clip-inner">How the engine <em class="serif-accent process__gold">runs</em>.</span></span></h2>

      <div class="process__rule" aria-hidden="true"></div>

      <ol class="process__grid">
        ${cells}
      </ol>
    </div>`;
}
function initProcess(ctx) {
  const { gsap: gsap4, ScrollTrigger: ScrollTrigger3, site: site2 } = ctx || {};
  const root = document.getElementById("process");
  if (!root) return;
  ensureStyles4();
  const steps = Array.isArray(site2?.process) ? site2.process : [];
  if (!steps.length) return;
  root.classList.add("process");
  root.innerHTML = buildMarkup(steps);
  const head = root.querySelector(".process__head");
  const headRule = root.querySelector(".process__head-rule");
  const headLabels = Array.from(root.querySelectorAll(".process__head .microlabel"));
  const title = root.querySelector(".process__title");
  const titleInner = root.querySelector(".process__clip-inner");
  const rule = root.querySelector(".process__rule");
  const grid = root.querySelector(".process__grid");
  const cells = Array.from(root.querySelectorAll(".process__cell"));
  if (!gsap4 || !ScrollTrigger3 || REDUCED) {
    cells.forEach((el) => el.classList.add("is-on"));
    return;
  }
  gsap4.fromTo(
    headRule,
    { scaleX: 0 },
    {
      scaleX: 1,
      ease: "none",
      transformOrigin: "0 50%",
      scrollTrigger: { trigger: head, start: HEAD_START, end: HEAD_END, scrub: SCRUB }
    }
  );
  revealScrub(headLabels, {
    from: { opacity: 0, y: 10 },
    trigger: head,
    start: HEAD_START,
    end: HEAD_END,
    stagger: 0.12
  });
  revealScrub(titleInner, {
    from: { yPercent: 112 },
    trigger: title,
    start: HEAD_START,
    end: HEAD_END
  });
  gsap4.fromTo(
    rule,
    { scaleX: 0 },
    {
      scaleX: 1,
      ease: "none",
      transformOrigin: "0 50%",
      scrollTrigger: { trigger: rule, start: "top 88%", end: "top 55%", scrub: SCRUB }
    }
  );
  revealScrub(cells, {
    from: { opacity: 0, y: 44 },
    trigger: grid,
    start: "top 86%",
    end: "top 44%",
    stagger: 0.1
  });
  cells.forEach((el) => {
    ScrollTrigger3.create({
      trigger: el,
      start: "top 78%",
      end: "top 46%",
      scrub: true,
      onUpdate: (self) => {
        el.classList.toggle("is-on", self.progress >= 0.5);
      }
    });
  });
}
var process_default = initProcess;

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/sections/results.js
var results_exports = {};
__export(results_exports, {
  default: () => results_default,
  initResults: () => initResults
});
import gsap2 from "https://esm.sh/gsap@3.12.5";
var SECTION_ID2 = "results";
var CSS_HREF5 = "css/sections/results.css";
function ensureStyles5() {
  if (document.querySelector(`link[data-section-css="${SECTION_ID2}"]`)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = CSS_HREF5;
  link.setAttribute("data-section-css", SECTION_ID2);
  document.head.appendChild(link);
}
function esc6(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  })[c]);
}
function quoteMarkup(t, i) {
  const active = i === 0;
  return `<figure class="results__quote${active ? " is-active" : ""}" data-quote="${i}" aria-hidden="${active ? "false" : "true"}"><blockquote class="results__quote-text">&ldquo;${esc6(t.quote)}&rdquo;</blockquote><figcaption class="microlabel results__quote-who">${esc6(t.name)}, ${esc6(t.role)}</figcaption></figure>`;
}
function render2(el, results, growth) {
  const testimonials = Array.isArray(results.testimonials) ? results.testimonials : [];
  const clients = Array.isArray(results.clients) ? results.clients : [];
  const quotesHtml = testimonials.map(quoteMarkup).join("");
  const mqRun = clients.map((c) => `<span class="results__mq-item">${esc6(c)}</span>`).join('<span class="results__mq-dot" aria-hidden="true"></span>');
  el.innerHTML = `
    <div class="container">
      <h2 class="results__sr">${esc6(results.headline || "Results")}</h2>

      <header class="results__head">
        <span class="results__rule" aria-hidden="true"></span>
        <span class="microlabel">(05) Results</span>
        <span class="microlabel">Real accounts, real budgets</span>
      </header>

      <div class="results__statement">
        <p class="results__figure">
          <span class="results__clip"><span class="results__clip-inner"><span class="results__num" aria-label="Plus ${growth} percent">+${growth}%</span></span></span>
        </p>
        <p class="microlabel results__caption">Indexed revenue growth across managed accounts</p>
      </div>

      ${quotesHtml ? `
      <div class="results__quotes" aria-live="polite">
        <div class="results__clip">
          <div class="results__clip-inner results__quotes-stack">${quotesHtml}</div>
        </div>
      </div>` : ""}
    </div>

    ${clients.length ? `
    <div class="results__mq hairline-top" aria-hidden="true">
      <div class="results__mq-track">
        <div class="results__mq-group">${mqRun}<span class="results__mq-dot"></span></div>
        <div class="results__mq-group">${mqRun}<span class="results__mq-dot"></span></div>
      </div>
    </div>` : ""}
  `;
}
function wireRotation(el) {
  const quotes = Array.from(el.querySelectorAll(".results__quote"));
  if (quotes.length <= 1 || REDUCED) return;
  let idx = 0;
  let timer = null;
  const DELAY = 7e3;
  function show(n) {
    idx = (n + quotes.length) % quotes.length;
    quotes.forEach((q, i) => {
      const active = i === idx;
      q.classList.toggle("is-active", active);
      q.setAttribute("aria-hidden", active ? "false" : "true");
    });
  }
  function start() {
    if (!timer) timer = window.setInterval(() => show(idx + 1), DELAY);
  }
  function stop() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => e.isIntersecting ? start() : stop());
    }, { threshold: 0.2 });
    io.observe(el);
  } else {
    start();
  }
}
function wireMotion(el, growth) {
  const head = el.querySelector(".results__head");
  const rule = el.querySelector(".results__rule");
  const figure = el.querySelector(".results__figure");
  const figureRise = el.querySelector(".results__figure .results__clip-inner");
  const num = el.querySelector(".results__num");
  const caption = el.querySelector(".results__caption");
  const quotes = el.querySelector(".results__quotes");
  const quotesRise = el.querySelector(".results__quotes .results__clip-inner");
  if (rule && !REDUCED) {
    gsap2.fromTo(rule, { scaleX: 0 }, {
      scaleX: 1,
      ease: "none",
      transformOrigin: "0 50%",
      scrollTrigger: { trigger: head, start: "top 92%", end: "top 72%", scrub: SCRUB }
    });
  }
  if (head) {
    revealScrub(head.querySelectorAll(".microlabel"), {
      from: { opacity: 0, y: 10 },
      trigger: head,
      start: "top 92%",
      end: "top 72%",
      stagger: 0.1
    });
  }
  if (figureRise) {
    revealScrub(figureRise, {
      from: { yPercent: 112 },
      trigger: figure || figureRise,
      start: "top 82%",
      end: "top 55%"
    });
  }
  if (num) {
    countScrub(num, growth, {
      trigger: figure || num,
      start: "top 85%",
      end: "top 40%",
      format: (v) => `+${Math.round(v)}%`
    });
  }
  if (caption) {
    revealScrub(caption, {
      from: { opacity: 0, y: 16 },
      trigger: figure || caption,
      start: "top 62%",
      end: "top 38%"
    });
  }
  if (quotesRise) {
    revealScrub(quotesRise, {
      from: { yPercent: 112 },
      trigger: quotes || quotesRise,
      start: "top 82%",
      end: "top 55%"
    });
  }
}
function initResults(ctx = {}) {
  const el = document.getElementById(SECTION_ID2);
  if (!el) return;
  ensureStyles5();
  const results = ctx.site && ctx.site.results || {};
  const chart = Array.isArray(results.chart) && results.chart.length >= 2 ? results.chart : [10, 100];
  const first = chart[0] || 1;
  const last = chart[chart.length - 1];
  const growth = Math.round((last - first) / Math.abs(first) * 100);
  render2(el, results, growth);
  wireMotion(el, growth);
  wireRotation(el);
}
var results_default = initResults;

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/sections/cta.js
var cta_exports = {};
__export(cta_exports, {
  default: () => cta_default,
  initCta: () => initCta
});
var CSS_HREF6 = "css/sections/cta.css";
function ensureStylesheet2(href) {
  const already = Array.from(document.styleSheets || []).some(
    (s) => s.href && s.href.endsWith(href)
  );
  const tagged = document.querySelector(`link[data-cta-style="${href}"]`);
  if (already || tagged) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.setAttribute("data-cta-style", href);
  document.head.appendChild(link);
}
function esc7(value) {
  return String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
var ARROW_SVG = '<svg class="cta__talk-arrow" viewBox="0 0 32 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" aria-hidden="true"><path d="M2 12h26"/><path d="m19 3 9 9-9 9"/></svg>';
function initCta(ctx) {
  const { gsap: gsap4, ScrollTrigger: ScrollTrigger3, site: site2 } = ctx || {};
  const ctaEl = document.getElementById("cta");
  const footerEl = document.getElementById("footer");
  if (!ctaEl && !footerEl) return;
  ensureStylesheet2(CSS_HREF6);
  const brand = site2 && site2.brand || {};
  const email = brand.email || "info@daamediasolutions.ae";
  const phone = brand.phone || "";
  const name = brand.name || "DAA Media Solutions";
  if (ctaEl) {
    const phoneLink = phone ? `<a class="btn" href="tel:${esc7(phone.replace(/\s+/g, ""))}">${esc7(phone)}</a>` : "";
    ctaEl.innerHTML = `
      <img class="cta__art" src="${(window.DAA_ASSETS && window.DAA_ASSETS.artLiquid) || 'assets/art-liquid.jpg'}" alt="" aria-hidden="true"
           width="1920" height="1080" loading="lazy" decoding="async" />

      <div class="container cta__inner">
        <header class="cta__head">
          <span class="cta__rule" aria-hidden="true"></span>
          <span class="microlabel">(06) Contact</span>
          <span class="microlabel cta__head-note">Replies within one business day</span>
        </header>

        <a class="cta__talk" href="mailto:${esc7(email)}" aria-label="Email ${esc7(name)}"><span
          class="cta__clip"><span class="cta__clip-inner">LET&#39;S <em
          class="serif-accent cta__talk-gold">talk</em>${ARROW_SVG}</span></span></a>

        <div class="cta__links">
          <a class="btn" href="mailto:${esc7(email)}">${esc7(email)}</a>
          ${phoneLink}
        </div>

        <div class="cta__formwrap">
          <form class="cta__form" novalidate aria-label="Contact ${esc7(name)}">
            <div class="cta__field">
              <label class="microlabel" for="cta-name">(A) Name</label>
              <input class="cta__input" id="cta-name" name="name" type="text" required
                     autocomplete="name" placeholder="Your name" />
              <span class="cta__error">Please tell us your name.</span>
            </div>
            <div class="cta__field">
              <label class="microlabel" for="cta-email">(B) Email</label>
              <input class="cta__input" id="cta-email" name="email" type="email" required
                     autocomplete="email" placeholder="you@company.com" />
              <span class="cta__error">A valid email keeps us in the loop.</span>
            </div>
            <div class="cta__field cta__field--full">
              <label class="microlabel" for="cta-message">(C) What do you need?</label>
              <textarea class="cta__input" id="cta-message" name="message" required rows="3"
                        placeholder="Platforms, monthly ad budget, current ROAS, biggest blocker."></textarea>
              <span class="cta__error">A line or two helps us help you.</span>
            </div>
            <div class="cta__actions">
              <button type="submit" class="btn btn--fill cta__submit">Send it over</button>
            </div>
          </form>

          <div class="cta__success" role="status" aria-live="polite">
            <p class="microlabel cta__success-tag">(OK) Message ready</p>
            <p class="cta__success-copy">Your email client just opened with everything
               filled in. Hit send and we reply within one business day.</p>
            <button type="button" class="btn cta__reset">Send another</button>
          </div>
        </div>
      </div>
    `;
    wireForm(ctaEl, email, name);
  }
  if (footerEl) {
    footerEl.innerHTML = `
      <div class="container">
        <div class="footer__row">
          <div class="footer__brand">
            <a class="microlabel footer__mark" href="#hero">${esc7(name)}</a>
            <span class="microlabel">IFZA Business Park, Dubai</span>
          </div>

          <nav class="footer__nav" aria-label="Footer navigation">
            <a class="microlabel" href="#hero">Home</a>
            <a class="microlabel" href="#services">Services</a>
            <a class="microlabel" href="#packages">Packages</a>
            <a class="microlabel" href="#cta">Contact</a>
          </nav>

          <div class="footer__legal">
            <a class="microlabel" href="https://daamediasolutions.ae/pages/privacy-policy">Privacy</a>
            <a class="microlabel" href="https://daamediasolutions.ae/pages/refund-policy">Refund</a>
            <a class="microlabel" href="https://daamediasolutions.ae/pages/terms-and-conditions">Terms</a>
            <span class="microlabel">&copy; 2026 ${esc7(name)} FZCO</span>
          </div>
        </div>
      </div>
    `;
  }
  if (!gsap4 || !ScrollTrigger3 || REDUCED) return;
  if (ctaEl) {
    const head = ctaEl.querySelector(".cta__head");
    const headLabels = ctaEl.querySelectorAll(".cta__head .microlabel");
    const rule = ctaEl.querySelector(".cta__rule");
    const talk = ctaEl.querySelector(".cta__talk");
    const talkInner = ctaEl.querySelector(".cta__clip-inner");
    const links = ctaEl.querySelectorAll(".cta__links .btn");
    const fields = ctaEl.querySelectorAll(".cta__field, .cta__actions");
    const art = ctaEl.querySelector(".cta__art");
    if (rule && head) {
      gsap4.fromTo(
        rule,
        { scaleX: 0 },
        {
          scaleX: 1,
          ease: "none",
          transformOrigin: "0 50%",
          scrollTrigger: { trigger: head, start: "top 92%", end: "top 76%", scrub: SCRUB }
        }
      );
    }
    if (headLabels.length) {
      revealScrub(headLabels, {
        trigger: head,
        from: { opacity: 0, y: 10 },
        start: "top 92%",
        end: "top 76%",
        stagger: 0.06
      });
    }
    if (talkInner) {
      revealScrub(talkInner, {
        trigger: talk,
        from: { yPercent: 112 },
        start: "top 82%",
        end: "top 55%"
      });
    }
    if (links.length) {
      revealScrub(links, {
        trigger: links[0],
        from: { opacity: 0, y: 20 },
        start: "top 94%",
        end: "top 76%",
        stagger: 0.08
      });
    }
    if (fields.length) {
      revealScrub(fields, {
        trigger: fields[0],
        from: { opacity: 0, y: 26 },
        start: "top 96%",
        end: "top 78%",
        stagger: 0.07
      });
    }
    if (art) parallax(art, { yPercent: -5 });
  }
}
function wireForm(ctaEl, email, brandName) {
  const wrap = ctaEl.querySelector(".cta__formwrap");
  const form = ctaEl.querySelector(".cta__form");
  if (!wrap || !form) return;
  const resetBtn = ctaEl.querySelector(".cta__reset");
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    form.classList.add("was-validated");
    if (!form.checkValidity()) {
      const firstBad = form.querySelector(":invalid");
      if (firstBad && typeof firstBad.focus === "function") firstBad.focus();
      return;
    }
    const data = new FormData(form);
    const senderName = (data.get("name") || "").toString().trim();
    const senderEmail = (data.get("email") || "").toString().trim();
    const message = (data.get("message") || "").toString().trim();
    const subject = `New enquiry from ${senderName} for ${brandName}`;
    const body = `Name: ${senderName}
Email: ${senderEmail}

${message}
`;
    const mailto = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailto;
    wrap.classList.add("is-sent");
  });
  if (resetBtn) {
    resetBtn.addEventListener("click", () => {
      wrap.classList.remove("is-sent");
      form.classList.remove("was-validated");
      form.reset();
      const firstField = form.querySelector("input");
      if (firstField && typeof firstField.focus === "function") firstField.focus();
    });
  }
}
var cta_default = initCta;

// ../../../../../../Users/Dylan/Claude/Own/daa-redesign/js/main.js
gsap3.registerPlugin(ScrollTrigger2);
var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
var finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
var SECTIONS = [
  { name: "hero", init: "initHero", mod: hero_exports },
  { name: "proof", init: "initProof", mod: proof_exports },
  { name: "services", init: "initServices", mod: services_exports },
  { name: "packages", init: "initPackages", mod: packages_exports },
  { name: "process", init: "initProcess", mod: process_exports },
  { name: "results", init: "initResults", mod: results_exports },
  { name: "cta", init: "initCta", mod: cta_exports }
];
var lenis = null;
function startLenis() {
  lenis = new Lenis({
    duration: 1.1,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: !prefersReducedMotion,
    // When reduced motion is requested, fall back to native scroll behavior.
    wheelMultiplier: 1,
    touchMultiplier: 1.4
  });
  lenis.on("scroll", ScrollTrigger2.update);
  gsap3.ticker.add((time) => lenis.raf(time * 1e3));
  gsap3.ticker.lagSmoothing(0);
  return lenis;
}
async function startScene() {
  const canvas = document.getElementById("bg");
  if (!canvas) return null;
  if (prefersReducedMotion) return null;
  try {
    if (typeof initScene !== "function") return null;
    const scene = initScene(canvas, { reducedMotion: prefersReducedMotion });
    return scene || null;
  } catch (err) {
    console.warn("[scene] failed to initialize, continuing without 3D bg.", err);
    return null;
  }
}
function wireGlobalProgress(scene) {
  const bar = document.getElementById("scroll-progress");
  ScrollTrigger2.create({
    start: 0,
    end: "max",
    onUpdate: (self) => {
      const p = self.progress;
      if (bar) bar.style.transform = `scaleX(${p})`;
      if (scene && typeof scene.setProgress === "function") scene.setProgress(p);
    }
  });
}
function wirePointer(scene) {
  const cursor = document.getElementById("cursor");
  const ring = document.getElementById("cursor-ring");
  const useCursor = finePointer && !prefersReducedMotion && cursor && ring;
  if (useCursor) document.body.classList.add("has-cursor");
  let rx = window.innerWidth / 2;
  let ry = window.innerHeight / 2;
  let cx = rx;
  let cy = ry;
  function onMove(e) {
    rx = e.clientX;
    ry = e.clientY;
    const nx = e.clientX / window.innerWidth * 2 - 1;
    const ny = e.clientY / window.innerHeight * 2 - 1;
    if (scene && typeof scene.setPointer === "function") scene.setPointer(nx, ny);
    if (useCursor) {
      cursor.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
    }
  }
  window.addEventListener("pointermove", onMove, { passive: true });
  if (useCursor) {
    const trail = () => {
      cx += (rx - cx) * 0.18;
      cy += (ry - cy) * 0.18;
      ring.style.transform = `translate(${cx}px, ${cy}px) translate(-50%, -50%)`;
      requestAnimationFrame(trail);
    };
    requestAnimationFrame(trail);
    const hoverSel = 'a, button, .btn, [data-cursor="hover"]';
    document.addEventListener("pointerover", (e) => {
      if (e.target.closest(hoverSel)) document.body.classList.add("cursor-hover");
    });
    document.addEventListener("pointerout", (e) => {
      if (e.target.closest(hoverSel)) document.body.classList.remove("cursor-hover");
    });
  }
}
async function loadSections(ctx) {
  for (const { name, init, mod } of SECTIONS) {
    try {
      const fn = mod[init];
      if (typeof fn === "function") {
        await fn(ctx);
      } else {
        console.warn(`[section:${name}] missing export ${init}() \u2014 skipped.`);
      }
    } catch (err) {
      console.warn(`[section:${name}] failed to init \u2014 skipped.`, err);
    }
  }
  ScrollTrigger2.refresh();
}
async function boot() {
  startLenis();
  const scene = await startScene();
  wireGlobalProgress(scene);
  wirePointer(scene);
  window.addEventListener("resize", () => {
    if (scene && typeof scene.resize === "function") scene.resize();
    ScrollTrigger2.refresh();
  }, { passive: true });
  document.addEventListener("visibilitychange", () => {
    if (!scene) return;
    if (document.hidden) scene.pause && scene.pause();
    else scene.resume && scene.resume();
  });
  const ctx = { gsap: gsap3, ScrollTrigger: ScrollTrigger2, lenis, scene, site, motion: motion_exports };
  await loadSections(ctx);
  const remeasure = () => {
    if (lenis && typeof lenis.resize === "function") lenis.resize();
    ScrollTrigger2.refresh();
  };
  remeasure();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(remeasure).catch(() => {
    });
  }
  window.addEventListener("load", remeasure, { once: true });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
